import React, { FC, useCallback } from 'react';
import { Logo } from '../../../shared/components';
import { LogoProps } from '../../../shared/components/Logo';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { useHistory } from 'react-router';
import { useUser } from '../../../shared';
import { currentEnv } from 'src';

export const appLogoFull = process.env.REACT_APP_LOGO_FULL;
export const localBasePathUrl = process.env.REACT_APP_LOCAL_BASE_PATH_URL;
export const stagingBasePathUrl = process.env.REACT_APP_STAGING_BASE_PATH_URL;
export const prodBasePathUrl = process.env.REACT_APP_PROD_BASE_PATH_URL;

const AppBarLogo: FC<LogoProps> = (props) => {
  const { getPath } = useI18nPath();
  const history = useHistory();
  const { isStudent } = useUser();

  const handleLogoClick = useCallback(() => {
    if (isStudent) {
      history.push(getPath('studentDashboard'));
    } else {
      const newPath = getPath('books');

      if (currentEnv === 'demo') {
        let redirectURL = '';
        if (
          window.location.href.indexOf('staging') !== -1 ||
          window.location.href.indexOf('localhost') !== -1
        ) {
          redirectURL = `${stagingBasePathUrl}${newPath}`;
        } else {
          redirectURL = `${prodBasePathUrl}${newPath}`;
        }
        const absoluteURL = new URL(redirectURL, window.location.origin).href;
        return setTimeout(() => {
          window.location.href = absoluteURL;
        }, 0);
      } else {
        history.push(newPath);
      }
    }
  }, [isStudent, history, getPath]);

  return (
    <Logo size="small" {...props} id="app_bar_logo" variant={'simple'} onClick={handleLogoClick} />
  );
};

export default AppBarLogo;
